module.exports = __webpack_public_path__ + "static/img/CK.117ec973.svg";